// removed by extract-text-webpack-plugin
module.exports = {"eventListItem":"src-components-events----EventList-module---eventListItem---KUqfp","eventList":"src-components-events----EventList-module---eventList---28pZ5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/events/EventList.module.css
// module id = 181
// module chunks = 35783957827783 36829835628245 276599015875551